<template>
  <div class="rental-publish">
    <div class="content">
      <!-- 已发布房源 -->
      <section class="section" v-if="publishedList.length">
        <h2 class="section-title">已发布房源</h2>
        <div class="card-list">
          <div class="house-card" v-for="item in publishedList" :key="item.buildingId">
            <div class="card-header">
              <div class="header-left">
                <h3 class="card-title">{{ item.subareaName }} {{ item.buildingName }}</h3>
                <p class="location">
                  <van-icon name="location-o" />
                  {{ item.communityName }}
                </p>
              </div>
              <div class="status-switch">
                <span class="status-text">上架中</span>
                <van-switch v-model="item.listingStatus" size="16" active-color="#1e5bff" @change="toggleStatus(item, $event)" />
              </div>
            </div>
            <p class="card-desc">{{ item.descriptionZh }}</p>
            <div class="tags">
              <span class="tag" v-for="(tag, index) in (item.tags || [])" :key="index">{{ tag }}</span>
            </div>
            <div class="card-footer">
              <span class="price">¥{{ item.minRent && item.maxRent ? item.minRent + '-' + item.maxRent : item.minRent || item.maxRent }}</span>
              <button class="edit-btn" @click="goEdit(item)">
                <van-icon name="edit" />
                编辑房源
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 未发布房源 -->
      <section class="section" v-if="unpublishedList.length">
        <h2 class="section-title">未发布房源</h2>
        <div class="card-list">
          <div class="house-card" v-for="item in unpublishedList" :key="item.buildingId">
            <div class="card-header">
              <div class="header-left">
                <h3 class="card-title">{{ item.subareaName }} {{ item.buildingName }}</h3>
                <p class="location">
                  <van-icon name="location-o" />
                  {{ item.communityName }}
                </p>
              </div>
              <div class="status-switch" v-if="item.listingId">
                <span class="status-text">未发布</span>
                <van-switch v-model="item.listingStatus" size="16" active-color="#1e5bff" @change="toggleStatus(item, $event)" />
              </div>
            </div>
            <p class="card-desc" v-if="item.listingId">{{ item.descriptionZh }}</p>
            <div class="tags" v-if="item.listingId">
              <span class="tag" v-for="(tag, index) in (item.tags || [])" :key="index">{{ tag }}</span>
            </div>
            <div class="card-footer">
              <span class="price disabled" v-if="item.listingId">¥{{ item.minRent && item.maxRent ? item.minRent + '-' + item.maxRent : item.minRent || item.maxRent }}</span>
              <button class="edit-btn" @click="item.listingId ? goEdit(item) : goPublish(item)">
                <van-icon :name="item.listingId ? 'edit' : 'plus'" />
                {{ item.listingId ? '编辑房源' : '新增房源' }}
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 已发布与未发布均为空 -->
      <van-empty v-if="!publishedList.length && !unpublishedList.length" description="暂无房源">
        <p class="empty-tip">如果不是房主本人，需要房主设为房屋管理员后才能发布房源</p>
      </van-empty>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      list: []
    }
  },
  computed: {
    publishedList() {
      return this.list.filter(item => item.listingStatus === true)
    },
    unpublishedList() {
      return this.list.filter(item => item.listingStatus === false)
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.$toast.loading({ duration: 0, message: '加载中...', forbidClick: true })
      this.$httpCustApp({
        url: this.$httpCustApp.adornUrl('/wxapp/landlord/listing/myHouses'),
        method: 'get',
        params: this.$httpCustApp.adornParams({})
      }).then(({ data }) => {
        this.$toast.clear()
        if (data.code === 0) {
          this.list = (data.list || []).map(item => ({
            ...item,
            listingStatus: item.listingStatus === 1 ? true : false
          }))
        } else {
          this.$toast.fail({ duration: 1500, forbidClick: true, message: data.msg || '加载失败' })
        }
      }).catch(() => {
        this.$toast.clear()
        this.$toast.fail({ duration: 1500, forbidClick: true, message: '加载失败' })
      })
    },
    toggleStatus(item, event) {
      const newStatus = event ? 1 : 0
      const actionName = newStatus === 1 ? '上架' : '下架'
      item.listingStatus = !event
      this.$dialog.confirm({
        title: '确认操作',
        message: '确定要' + actionName + '该房源吗？'
      }).then(() => {
        item.listingStatus = event
        this.$toast.loading({ duration: 0, message: '处理中...', forbidClick: true })
        this.$httpCustApp({
          url: this.$httpCustApp.adornUrl('/wxapp/landlord/listing/updateStatus'),
          method: 'post',
          data: this.$httpCustApp.adornData({
            listingId: item.listingId,
            status: newStatus
          })
        }).then(({ data }) => {
          this.$toast.clear()
          if (data.code === 0) {
            this.$toast.success(newStatus === 1 ? '已上架' : '已下架')
            item.listingStatus = event
          } else {
            item.listingStatus = !event
            this.$toast.fail({ duration: 1500, forbidClick: true, message: data.msg || '操作失败' })
          }
        }).catch(() => {
          this.$toast.clear()
          item.listingStatus = !event
          this.$toast.fail({ duration: 1500, forbidClick: true, message: '操作失败' })
        })
      }).catch(() => {})
    },
    goPublish(item) {
      this.$router.push({
        path: '/saveCode-rental-edit',
        query: {
          id: item.listingId,
          buildingId: item.buildingId,
          subarea: item.subarea,
          community: item.community,
          street: item.street,
          address: item.communityName + item.subareaName + item.buildingName,
          landlordId: item.landlordId
        }
      })
    },
    goEdit(item) {
      this.$router.push({
        path: '/saveCode-rental-edit',
        query: {
          id: item.listingId,
          subarea: item.subarea,
          community: item.community,
          street: item.street,
          address: item.communityName + item.subareaName + item.buildingName,
          landlordId: item.landlordId
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.rental-publish {
  min-height: 100vh;
  // background: linear-gradient(180deg, #c3d2f9 0%, #eef4ff 48%, #ffffff 100%);
  padding-bottom: 80px;

  .content {
    padding: 29px;
  }

  .empty-tip {
    font-size: 22px;
    color: #9b9b9b;
    line-height: 1.6;
    padding: 0 40px;
    margin-top: -10px;
  }

  .section {
    margin-bottom: 40px;

    .section-title {
      font-size: 28px;
      font-weight: 800;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 2px;
      margin-bottom: 25px;
    }
  }

  .card-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
  }

  .house-card {
    background: #fff;
    border-radius: 29px;
    padding: 29px;
    box-shadow: 0 7px 14px rgba(0, 0, 0, 0.12);
    border: 2px solid rgba(170, 173, 176, 0.05);

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 18px;

      .header-left {
        flex: 1;

        .card-title {
          font-size: 27px;
          font-weight: 800;
          color: #0b1f3f;
          margin: 0 0 8px 0;
        }

        .location {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 18px;
          color: #9b9b9b;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
      }

      .status-switch {
        display: flex;
        align-items: center;
        gap: 11px;

        .status-text {
          font-size: 18px;
          font-weight: 800;
          color: #1e5bff;
        }
      }
    }

    .card-desc {
      font-size: 22px;
      color: #555;
      line-height: 1.6;
      margin-bottom: 18px;
    }

    .tags {
      display: flex;
      flex-wrap: wrap;
      gap: 11px;
      margin-bottom: 22px;

      .tag {
        padding: 5px 14px;
        border-radius: 11px;
        background: #d9e4ff;
        color: #1e5bff;
        font-size: 18px;
        font-weight: 800;
        border: 2px solid rgba(30, 91, 255, 0.1);
      }
    }

    .card-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 18px;
      border-top: 2px solid #eef4ff;

      .price {
        font-size: 32px;
        font-weight: 800;
        color: #1e5bff;

        &.disabled {
          color: #9b9b9b;
        }
      }

      .edit-btn {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 11px 20px;
        background: #eef4ff;
        border-radius: 14px;
        border: 0;
        color: #0b1f3f;
        font-size: 18px;
        font-weight: 700;
        cursor: pointer;
        transition: all 0.2s;
        margin-left: auto;

        &:active {
          transform: scale(0.95);
        }
      }
    }
  }
}
</style>
